/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LasgroNotification_tagCollection } from '../models/lasgro-notification-_tag-collection';
@Injectable({
  providedIn: 'root',
})
class NotificationTagService extends __BaseService {
  static readonly notificationTagListPath = '/notifications/tags';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list notification_tag
   *
   * List all of the notification tags
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  notificationTagListResponse(): __Observable<__StrictHttpResponse<LasgroNotification_tagCollection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/notifications/tags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LasgroNotification_tagCollection>;
      })
    );
  }
  /**
   * list notification_tag
   *
   * List all of the notification tags
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  notificationTagList(): __Observable<LasgroNotification_tagCollection> {
    return this.notificationTagListResponse().pipe(
      __map(_r => _r.body as LasgroNotification_tagCollection)
    );
  }
}

module NotificationTagService {
}

export { NotificationTagService }
